import { get } from 'lodash'
import routes from '~/const/routes'

export const state = () => ({
  items: [],
  meta: {
    totalItems: null
  },
  requestParams: null
})

export const getters = {
  items: state => state.items,
  meta: state => state.meta,
  requestParams: state => state.requestParams
}

export const mutations = {
  RESET(state) {
    state.items = []
    state.meta = { totalItems: null }
    state.requestParams = null
  }
}

export const actions = {
  async getAll({ commit }, { config = {} }) {
    const { data, meta } = get(await this.$axios.get(routes.act.list(), config), 'data')

    commit(
      'AFTER_GET_ALL',
      {
        namespace: 'acts',
        items: data,
        meta,
        params: config.params
      },
      { root: true }
    )

    return { data, meta }
  },
  async downloadAct({ commit }, { id, type = 'signed' } = {}) {
    const { data } = await this.$axios.get(routes.act.downloadAct(id), {
      responseType: 'blob',
      params: {
        type
      }
    })

    return data
  },
  downloadReconciliationAct({ commit }, payload) {
    return this.$axios.post(routes.act.downloadReconciliationAct(), payload, {
      responseType: 'blob'
    })
  },
  signAct({ commit }, { id, payload }) {
    return this.$axios.post(routes.act.sign(id), payload)
  }
}
